import React from 'react'

function Contact() {
  return (
    <div>
      <h1>contact</h1>
    </div>
  )
}

export default Contact
